import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

// 创建store，状态管理器
const store = new Vuex.Store({
  modules: {},
  state: {
    isLoggedIn: false,
    username: "",
  },
  mutations: {
    login(state, username) {
      state.isLoggedIn = true;
      state.username = username;
    },
    logout(state) {
      state.isLoggedIn = false;
      state.username = "";
    },
  },
  actions: {
    login({ commit }, username) {
      commit("login", username);
      // 这里可以添加更多的登录逻辑，比如 API 调用
    },
    logout({ commit }) {
      commit("logout");
      // 这里可以添加更多的登出逻辑，比如 API 调用
    },
  },
  // plugins: [vuexHome, vuexAbout],
});
export default store;
